import axios from '@/common/request/request'
// import CryptoJS from 'crypto-js'
import { getToken } from '@/storage/viewStorage'
// import md5 from 'md5-node'
require('./oos-sdk-6.0.min')
const mapcontenttypetosuffix = { 'application/vnd.android.package-archive': 'apk', 'video/3gpp': '3gp', 'application/postscript': 'ps', 'audio/x-aiff': 'aiff', 'text/plain': 'txt', 'application/atom+xml': 'atom', 'audio/basic': 'snd', 'video/x-msvideo': 'avi', 'application/x-bcpio': 'bcpio', 'application/octet-stream': 'so', 'image/bmp': 'bmp', 'application/x-netcdf': 'nc', 'image/cgm': 'cgm', 'application/x-cpio': 'cpio', 'application/mac-compactpro': 'cpt', 'application/x-csh': 'csh', 'text/css': 'css', 'application/x-director': 'dxr', 'video/x-dv': 'dv', 'image/vnd.djvu': 'djvu', 'application/msword': 'doc', 'application/xml-dtd': 'dtd', 'application/x-dvi': 'dvi', 'text/x-setext': 'etx', 'application/andrew-inset': 'ez', 'video/x-flv': 'flv', 'image/gif': 'gif', 'application/srgs': 'gram', 'application/srgs+xml': 'grxml', 'application/x-gtar': 'gtar', 'application/x-gzip': 'gz', 'application/x-hdf': 'hdf', 'application/mac-binhex40': 'hqx', 'text/html': 'html', 'x-conference/x-cooltalk': 'ice', 'image/x-icon': 'ico', 'text/calendar': 'ifb', 'image/ief': 'ief', 'model/iges': 'igs', 'application/x-java-jnlp-file': 'jnlp', 'image/jp2': 'jp2', 'image/jpeg': 'jpg', 'application/x-javascript': 'js', 'audio/midi': 'midi', 'application/x-latex': 'latex', 'audio/x-mpegurl': 'm3u', 'audio/mp4a-latm': 'm4p', 'video/vnd.mpegurl': 'mxu', 'video/x-m4v': 'm4v', 'image/x-macpaint': 'pntg', 'application/x-troff-man': 'man', 'application/mathml+xml': 'mathml', 'application/x-troff-me': 'me', 'model/mesh': 'silo', 'application/vnd.mif': 'mif', 'video/quicktime': 'qt', 'video/x-sgi-movie': 'movie', 'audio/mpeg': 'mp3', 'video/mp4': 'mp4', 'video/mpeg': 'mpg', 'application/x-troff-ms': 'ms', 'application/oda': 'oda', 'application/ogg': 'ogg', 'video/ogv': 'ogv', 'image/x-portable-bitmap': 'pbm', 'image/pict': 'pict', 'chemical/x-pdb': 'pdb', 'application/pdf': 'pdf', 'image/x-portable-graymap': 'pgm', 'application/x-chess-pgn': 'pgn', 'image/png': 'png', 'image/x-portable-anymap': 'pnm', 'image/x-portable-pixmap': 'ppm', 'application/vnd.ms-powerpoint': 'ppt', 'image/x-quicktime': 'qtif', 'audio/x-pn-realaudio': 'ram', 'image/x-cmu-raster': 'ras', 'application/rdf+xml': 'rdf', 'image/x-rgb': 'rgb', 'application/vnd.rn-realmedia': 'rm', 'application/x-troff': 'tr', 'text/rtf': 'rtf', 'text/richtext': 'rtx', 'text/sgml': 'sgml', 'application/x-sh': 'sh', 'application/x-shar': 'shar', 'application/x-stuffit': 'sit', 'application/x-koan': 'skt', 'application/smil': 'smil', 'application/x-futuresplash': 'spl', 'application/x-wais-source': 'src', 'application/x-sv4cpio': 'sv4cpio', 'application/x-sv4crc': 'sv4crc', 'image/svg+xml': 'svg', 'application/x-shockwave-flash': 'swf', 'application/x-tar': 'tar', 'application/x-tcl': 'tcl', 'application/x-tex': 'tex', 'application/x-texinfo': 'texinfo', 'image/tiff': 'tiff', 'text/tab-separated-values': 'tsv', 'application/x-ustar': 'ustar', 'application/x-cdlink': 'vcd', 'model/vrml': 'wrl', 'application/voicexml+xml': 'vxml', 'audio/x-wav': 'wav', 'image/vnd.wap.wbmp': 'wbmp', 'application/vnd.wap.wbxml': 'wbxml', 'video/webm': 'webm', 'text/vnd.wap.wml': 'wml', 'application/vnd.wap.wmlc': 'wmlc', 'text/vnd.wap.wmlscript': 'wmls', 'application/vnd.wap.wmlscriptc': 'wmlsc', 'video/x-ms-wmv': 'wmv', 'image/x-xbitmap': 'xbm', 'application/xhtml+xml': 'xhtml', 'application/vnd.ms-excel': 'xls', 'application/xml': 'xsl', 'image/x-xpixmap': 'xpm', 'application/xslt+xml': 'xslt', 'application/vnd.mozilla.xul+xml': 'xul', 'image/x-xwindowdump': 'xwd', 'chemical/x-xyz': 'xyz', 'application/zip': 'zip' }
// 有 token 请求
function sessiontoken () {
  return axios.request({
    method: 'post',
    url: '/system/ctyun/context'
  })
}
// 没有 token 上传
function sessionUntoken () {
  return axios.request({
    method: 'post',
    url: '/system/ucAnonymous/guestContext'
  })
}

// 获取加签地址
function getSignPublicBucketPathFn (key) {
  return axios.request({
    method: 'post',
    url: '/system/ctyun/signPublicBucketPath',
    data: {
      key
    }
  })
}

// 是否视频
function isVideoFn (fileName) {
  const type = ['avi', 'flv', 'mpg', 'mpeg', 'mpe', 'm1v', 'm2v', 'mpv2', 'mp2v', 'dat', 'ts', 'tp', 'tpr', 'pva', 'pss', 'mp4', 'm4v',
    'm4p', 'm4b', '3gp', '3gpp', '3g2', '3gp2', 'ogg', 'mov', 'qt', 'amr', 'rm', 'ram', 'rmvb', 'rpm', 'mp3', 'm4a']
  const fileTypeArr = fileName.split('.')
  let fileType = fileTypeArr[fileTypeArr.length - 1]
  fileType = fileType && fileType.toLowerCase()
  return type.includes(fileType)
}
// testbucket:'jssztest' ,akid:'2de98f277d5340f33264',sk:'696e34cbb040a4a54a7c7d116b076a4388502f47'
const defaultconfig = {
  accessKeyId: '', // 用后台获取的替换
  secretAccessKey: '', // 用后台获取的替换
  endpoint: 'oos-cn.ctyunapi.cn',
  signatureVersion: 'v4', // 可选v2 或v4
  apiVersion: '2006-03-01',
  s3ForcePathStyle: true
}
// 需要下载的存储桶
let defaultbucket = 'default-bucket'
// 在线播放的存储桶
let onlineBucket = ''
// 图片上传共有桶
let pubBucket = ''
let bizBucket = ''
let tokenStr = ''
// const bizbucket = ''

// 占用测试桶

let prefix = ''
const defaultChunkSize = 6 * 1024 * 1024 // 最低6M每片
const maxtask = 8 // 最大10个同时上传

//
let ctyunClient
export function waitforclient (token) {
  if (token === undefined) {
    token = getToken()
  }
  tokenStr = token
  return new Promise((resolve, reject) => {
    if (ctyunClient) {
      resolve(ctyunClient)
    } else {
      if (!ctyunClient) {
        const opt = Object.assign({}, defaultconfig)
        if (token) {
          sessiontoken().then(res => {
            const jsonObj = res.data.data
            // let jsonstr = decryp(res.data.data.s)
            // let jsonObj = JSON.parse(jsonstr)
            // 这里需要再次解密
            opt.accessKeyId = jsonObj.accessKeyId
            opt.secretAccessKey = jsonObj.secretAccessKey
            opt.sessionToken = jsonObj.sessionToken
            opt.endpoint = jsonObj.endpoint || opt.endpoint
            defaultbucket = jsonObj.b
            onlineBucket = jsonObj.vod
            pubBucket = jsonObj.pub
            bizBucket = jsonObj.biz
            // eslint-disable-next-line
            ctyunClient = new OOS.S3(opt)
            resolve(ctyunClient)
          })
        } else {
          prefix = 'anonymous/'
          sessionUntoken().then(res => {
            const jsonObj = res.data.data
            // 这里需要再次解密
            opt.accessKeyId = jsonObj.accessKeyId
            opt.secretAccessKey = jsonObj.secretAccessKey
            opt.sessionToken = jsonObj.sessionToken
            opt.endpoint = jsonObj.endpoint || opt.endpoint
            defaultbucket = jsonObj.biz
            onlineBucket = jsonObj.vod
            pubBucket = jsonObj.biz
            bizBucket = jsonObj.biz
            // eslint-disable-next-line
            ctyunClient = new OOS.S3(opt)
            resolve(ctyunClient)
          })
        }
      }
    }
  })
}
function getClient (token) {
  if (token === undefined) {
    token = getToken()
  }
  tokenStr = token
  if (!ctyunClient) {
    const opt = Object.assign({}, defaultconfig)
    if (token) {
      sessiontoken().then(res => {
        const jsonObj = res.data.data
        // let jsonstr = decryp(res.data.data.s)
        // let jsonObj = JSON.parse(jsonstr)
        // 这里需要再次解密
        opt.accessKeyId = jsonObj.accessKeyId
        opt.secretAccessKey = jsonObj.secretAccessKey
        opt.sessionToken = jsonObj.sessionToken
        opt.endpoint = jsonObj.endpoint || opt.endpoint
        defaultbucket = jsonObj.b
        onlineBucket = jsonObj.vod
        pubBucket = jsonObj.pub
        bizBucket = jsonObj.biz
        // eslint-disable-next-line
        ctyunClient = new OOS.S3(opt)
      })
    } else {
      prefix = 'anonymous/'
      sessionUntoken().then(res => {
        const jsonObj = res.data.data
        // 这里需要再次解密
        opt.accessKeyId = jsonObj.accessKeyId
        opt.secretAccessKey = jsonObj.secretAccessKey
        opt.sessionToken = jsonObj.sessionToken
        opt.endpoint = jsonObj.endpoint || opt.endpoint
        defaultbucket = jsonObj.biz
        onlineBucket = jsonObj.vod
        pubBucket = jsonObj.biz
        bizBucket = jsonObj.biz
        // eslint-disable-next-line
        ctyunClient = new OOS.S3(opt)
      })
    }
  } else {
    return ctyunClient
  }
}

// 初始化oos
export const initOOsClient = (token) => {
  getClient(token)
}
// 初始化客户端

/**
 * 上传单个文件,小于5M用这个
 * @param {文件,dom的file对象} file
 * @param {参数,{key:置顶文件ID,baseUrl:用来配置返回的地址前缀,[bucket]是占位符}} opts
 * @returns {name:文件名,size:大小,key:文件id,type:minitype,etag:返回的etag} Promise.resolve
 * @returns {出错原因,string类型} Promise.reject
 */
export const putSmallObject = (file, opts) => {
  const fileOpts = {
    Bucket: defaultbucket
  }
  let filekey = buildKey(file)
  if (opts && opts.Key) {
    filekey = opts.Key
  }
  const bucketObj = {
    0: defaultbucket,
    1: onlineBucket,
    2: pubBucket,
    3: bizBucket
  }

  if (opts && opts.Bucket) {
    fileOpts.Bucket = opts.Bucket
  }
  if (isVideoFn(file.name)) {
    fileOpts.Bucket = onlineBucket
  }
  if (file.type.indexOf('image') > -1) {
    fileOpts.Bucket = pubBucket
  }
  if (opts && opts.bucketType) {
    // 桶配置
    fileOpts.Bucket = bucketObj[opts.bucketType]
  }
  // 返回数据结构
  const fileobj = {}
  fileobj.name = file.name
  fileobj.size = file.size
  fileobj.type = file.type
  fileobj.key = filekey
  fileobj.bucket = fileOpts.Bucket

  fileOpts.Key = filekey
  fileOpts.Body = file
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('请选择文件'))
    }
    getClient().putObject(fileOpts, (err, data) => {
      if (err) {
        reject(err)
      } else {
        if (tokenStr && fileOpts.Bucket === bucketObj[2]) {
          let baseUrl = `https://oos-cn.ctyunapi.cn/${fileOpts.Bucket}/`
          if (opts && opts.baseUrl) {
            baseUrl = opts.baseUrl.replace('[bucket]', fileOpts.Bucket) + '/'
          }
          fileobj.fileUrl = baseUrl + fileobj.key
          getSignPublicBucketPathFn(fileobj.key).then(res => {
            fileobj.onlineUrl = res.data.data
            resolve(fileobj)
          }).catch(() => {
            resolve(fileobj)
          })
        } else {
          getSignedUrl(fileobj.key, 900, fileOpts.Bucket).then(res => {
            fileobj.fileUrl = res
            resolve(fileobj)
          })
        }
      }
    })
  })
}
/**
 * 公共桶上传单个文件,小于5M用这个,不能用于视频
 * 图片不用加签，直接使用 https://oos-cn.ctyunapi.cn/public-bucket/ 前缀
 * @param {文件,dom的file对象} file
 * @param {参数,{key:置顶文件ID,}} opts
 * @returns {name:文件名,size:大小,key:文件id,type:minitype,etag:返回的etag} Promise.resolve
 * @returns {出错原因,string类型} Promise.reject
 */
export const putPublicSmallObject = (file, opts) => {
  const fileOpts = { Bucket: pubBucket }
  if (opts && opts.bucket) {
    fileOpts.Bucket = opts.bucket
  }
  if (isVideoFn(file.name)) {
    fileOpts.Bucket = onlineBucket
  }
  const filekey = buildKey(file)
  // 返回数据结构
  const fileobj = {}
  fileobj.name = file.name
  fileobj.size = file.size
  fileobj.type = file.type
  fileobj.key = filekey

  fileOpts.Key = filekey
  fileOpts.Body = file
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('请选择文件'))
    }
    getClient().putObject(fileOpts, (err, data) => {
      if (err) {
        reject(err)
      } else {
        let baseUrl = `https://oos-cn.ctyunapi.cn/${pubBucket}/`
        if (opts && opts.baseUrl) {
          baseUrl = opts.baseUrl.replace('[bucket]', pubBucket) + '/'
        }
        fileobj.fileUrl = baseUrl + fileobj.key
        getSignPublicBucketPathFn(fileobj.key).then(res => {
          fileobj.onlineUrl = res.data.data
          resolve(fileobj)
        })
      }
    })
  })
}

/**
 * 获得访问路径签名
 * @param {文件key,必填} key
 * @param {存储桶,默认default-bucket} bucket
 * @param {过期时间,单位秒,默认900} expires
 * @returns {返回文件地址} Promise.resolve
 * @returns {出错原因,string类型} Promise.reject
 */
export const getSignedUrl = (key, expires, bucket) => {
  const params = {}
  params.Key = key
  if (!expires) {
    expires = 900
  }
  if (!bucket) {
    bucket = defaultbucket
  }

  params.Bucket = bucket
  params.Expires = expires

  return new Promise((resolve, reject) => {
    if (!key) {
      reject(new Error('缺少key'))
    }
    getClient().getSignedUrl('getObject', params, (err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve(data)
      }
    })
  })
}

/**
 * 文件上传基础类
 * @param {分片序号} PartNumber
 * @param {标识哪一次上传} UploadIdId
 * @param {文件开始位置} start
 * @param {文件截止位置} end
 */
function UploadTask (PartNumber, start, end) {
  this.PartNumber = PartNumber
  this.start = start
  this.end = end
  this.step = 0
}
/**
 * 上传核心函数,一次上传1片
 * @param {上传需要的参数} ctx
 */
UploadTask.prototype.run = function (ctx) {
  const client = ctx.Client
  const startat = new Date().getTime()
  const that = this
  const args = {}
  args.Bucket = ctx.Bucket
  args.Key = ctx.Key
  const file = ctx.File.slice(this.start, this.end)
  args.Body = file
  // 这个是标识文件上传的ID
  args.UploadId = ctx.UploadId
  // 这个partnumber非常重要,用来后端获取数据
  args.PartNumber = this.PartNumber
  that.step = 1

  client.uploadPart(args, (err, data) => {
    if (err) {
      if (that.step > 0) {
        ctx.onerror(err)
      }
      that.step = 0
    } else {
      ctx.MultipartUpload.Parts.push({ PartNumber: that.PartNumber, ETag: data.ETag })
      const endat = new Date().getTime()
      ctx.onspeed(((that.end - that.start) * 1000) / (1024 * (endat - startat)))
      that.step = 2
    }
  })

  // let fileReader = new FileReader();
  // fileReader.readAsBinaryString(file);

  // fileReader.onload = function (e) {
  // //  let spark = new SparkMD5.ArrayBuffer()
  // //   spark.append(e.target.result)
  // //   let md5 =  spark.end()
  // //     if (md5){
  // //        // args["ContentMD5"] = btoa(md5);
  // //     }
}

/**
 * 这个类主要完成文件分片上传，具体初始化一些参数
 * @param {文件} file
 * @param {完成} oncomplete
 * @param {进度回调} onprogress
 * @param {出错回调} onerror
 * @param {速度读回调} onspeed
 */
function Context (file, oncomplete, onprogress, onerror, onspeed, opts) {
  this.File = file
  this.File = file
  this.Bucket = defaultbucket
  const bucketObj = {
    0: defaultbucket,
    1: onlineBucket,
    2: pubBucket,
    3: bizBucket
  }
  if (opts && opts.bucketType) {
    // 桶配置
    this.Bucket = bucketObj[opts.bucketType]
  }
  if (isVideoFn(file.name)) {
    this.Bucket = onlineBucket
  }
  if (opts && opts.Bucket) {
    this.Bucket = bucketObj[opts.Bucket]
  }
  this.Key = buildKey(file)
  this.Chunks = buildChunk(file)
  this.progress = 0.01
  const emptyfunc = function () {}
  if (typeof oncomplete !== 'function') {
    oncomplete = emptyfunc
  }
  if (typeof onprogress !== 'function') {
    onprogress = emptyfunc
  }
  if (typeof onerror !== 'function') {
    onerror = emptyfunc
  }
  if (typeof onspeed !== 'function') {
    onspeed = emptyfunc
  }
  this.onprogress = onprogress
  this.oncomplete = oncomplete
  this.onerror = onerror
  this.onspeed = onspeed
  // 完成的分块信息
  this.MultipartUpload = {
    Parts: []
  }
}
/**
 * 主要是初始化客户端
 * 并获取本次分片上传总任务编号uploadid
 */
Context.prototype.init = function () {
  const ctx = this
  ctx.Client = getClient()
  return new Promise((resolve, reject) => {
    const arg = {}
    arg.Bucket = ctx.Bucket
    arg.Key = ctx.Key
    ctx.Client.createMultipartUpload(arg, (err, data) => {
      if (err) {
        reject(err)
      } else {
        ctx.UploadId = data.UploadId

        ctx.buildTask()

        resolve(ctx)
      }
    })
  }).catch(err => {
    console.error(err)
  })
}
/**
 * 根据分片信息生成任务队列
 */
Context.prototype.buildTask = function () {
  const ctx = this
  const tasks = []
  for (let i = 0; i < ctx.Chunks.length; i++) {
    const chunk = ctx.Chunks[i]
    tasks.push(new UploadTask(chunk.PartNumber, chunk.start, chunk.end))
  }
  ctx.taskBuf = tasks
}

/**
 * 当所有分片上传完成后的回调
 */
Context.prototype.complete = function () {
  const ctx = this
  ctx.MultipartUpload.Parts.sort((a, b) => {
    return a.PartNumber - b.PartNumber
  })
  const params = {
    Bucket: ctx.Bucket,
    Key: ctx.Key,
    UploadId: ctx.UploadId,
    MultipartUpload: ctx.MultipartUpload
  }
  ctx.Client.completeMultipartUpload(params, (err, data) => {
    if (err) {
      ctx.onerror(err)
    } else {
      ctx.onprogress(1)
      // data{name:name,key:key,size}
      //
      const resp = {}
      resp.name = ctx.File.name
      resp.size = ctx.File.size
      resp.key = ctx.Key
      resp.bucket = ctx.Bucket
      const baseUrl = `https://oos-cn.ctyunapi.cn/${resp.bucket}/`
      resp.fileUrl = baseUrl + resp.key
      ctx.oncomplete(resp)
    }
  })
}
/**
 * 任务调度函数,本系统采用定时器检测,每500ms检测一下任务队列完成情况
 * 如果完成的任务数目====任务队列的总数目则任务是完成了
 */
Context.prototype.dispatch = function () {
  const ctx = this

  const taskBuf = ctx.taskBuf

  // 最小进度
  const minprogress = 0.01

  const doing = taskBuf.filter(o => o.step === 1)
  const complete = taskBuf.filter(o => o.step === 2)
  // 完成的任务数目 ===  任务队列总数目
  if (complete.length === taskBuf.length) {
    clearInterval(ctx.timer)
    ctx.complete()
    return
  }
  // 当前进度就是完成的任务数目/总数目
  let d = complete.length * 1.0 / taskBuf.length
  if (d < minprogress) {
    d = minprogress
  }
  ctx.onprogress(d)

  let tasknum = maxtask - doing.length
  taskBuf.forEach(t => {
    // 如果当前队列处于0:待调度
    if (t.step === 0) {
      // 剩余可用的任务>0则继续跑
      if (tasknum > 0) {
        t.run(ctx)
        tasknum = tasknum - 1
      }
    }
  })
}
/**
 * 开始任务调度
 */
Context.prototype.start = function () {
  // 用一个时间轮区处理分片上传问题
  const ctx = this
  ctx.timer = setInterval(() => {
    // eslint-disable-next-line
        ctx.dispatch.call(ctx)
  }, 500)
  // 500毫秒计数一下
  // this.dispatch()
}

/**
 * 输入文件输出文件ID,这个是uuid生成的和文件名称没有太多的关系
 * @param {输入的文件,支持blob对象} file
 */
function buildKey (file) {
  const UUID = require('uuid')
  const tmp = UUID.v4().replace('-', '')
  const key = tmp.substr(0, 1) + '/' + tmp.substr(0, 2) + '/' + tmp

  // {name:"微信图片_20201102170307.jpg",path:"C:\Users\CSQM-05\Desktop\微信图片_20201102170307.jpg",size:86501,type:"image/jpeg"}
  const contenttype = file.type
  // 从文件的type中属性中获取
  let suffix = mapcontenttypetosuffix[contenttype]
  // 如果不识别那么从文件后缀中提取
  if (!suffix) {
    const suffixArr = file.name.split('.')
    // 如果没有后缀那么直接返回空
    if (suffixArr === 0) {
      suffix = ''
    } else {
      suffix = suffixArr[suffixArr.length - 1]
    }
  }
  // 自动生成filekey
  const filekey = prefix + key + (suffix ? ('.' + suffix) : '')
  return filekey
  // return prefix + testfilekey +new Date().getTime()+ (suffix ? ('.' + suffix) : '')
  // return prefix + key + (suffix ? ('.' + suffix) : '')
}

/**
  * 返回文件切片对象
  * @param {文件对象} file
  * @param {分片,每片大小} chunkSize
  */
function buildChunk (file, chunkSize) {
  // {name:"微信图片_20201102170307.jpg",path:"C:\Users\CSQM-05\Desktop\微信图片_20201102170307.jpg",size:86501,type:"image/jpeg"}
  if (typeof chunkSize === 'undefined') {
    chunkSize = defaultChunkSize
  }
  const chunks = Math.ceil(file.size / chunkSize)
  let currentChunk = 0
  // 构建file数组
  // partItem = {start,end,index,stat}
  // stat:0 待处理,1处理中2已完成
  // start:分片文件开始位置,end:分片文件结束位置
  // index:当前多少片,用作partNo

  const tmp = []
  for (currentChunk = 0; currentChunk < chunks; currentChunk++) {
    // 第一次
    const start = currentChunk * chunkSize
    let end = start + chunkSize

    const obj = {}

    if (end >= file.size) {
      end = file.size
    }
    obj.start = start
    obj.end = end
    obj.PartNumber = currentChunk + 1
    tmp.push(obj)
  }

  return tmp
}
/**
 * 初始化并上传大文件
 * @param {文件} file
 * @param {进度条回调} onprocess
 * @param {完成回调} oncomplete
 * @param {出错回调} onerror
 * @param {文件的key} key
 * @param {存放的} bucket
 */
export const initAndPutBigObject = (file, oncomplete, onprogress, onerror, opts) => {
  const ctx = new Context(file, oncomplete, onprogress, onerror, null, opts)
  ctx.init().then(ctx => {
    ctx.start()
  })
}

// 下载资源
export const downloadResFn = (Key, Bucket) => {
  if (!Bucket) {
    Bucket = pubBucket
  }
  const params = {
    Bucket,
    Key
  }
  getClient().getObject(params, (err, data) => {
    console.log(578, data)
    console.log(577, err)
  })
}
